import { useState, useMemo } from "react";
import { PageI } from "../types";

export function useComponentMinimization(page: PageI | undefined) {
  const [minimizedComponents, setMinimizedComponents] = useState<{
    [key: string]: boolean;
  }>({});

  const areAllMinimized = useMemo(() => {
    if (!page?.components?.length) return false;
    return page.components.every(
      (component) => minimizedComponents[component._id] === true,
    );
  }, [page, minimizedComponents]);

  const handleMinimizeAll = () => {
    if (!page?.components?.length) return;
    const allMinimized: { [key: string]: boolean } = {};
    page.components.forEach((c) => {
      allMinimized[c._id] = true;
    });
    setMinimizedComponents((prev) => ({ ...prev, ...allMinimized }));
  };

  const handleExpandAll = () => {
    if (!page?.components?.length) return;
    const allExpanded: { [key: string]: boolean } = {};
    page.components.forEach((c) => {
      allExpanded[c._id] = false;
    });
    setMinimizedComponents((prev) => ({ ...prev, ...allExpanded }));
  };

  return {
    minimizedComponents,
    setMinimizedComponents,
    handleMinimizeAll,
    handleExpandAll,
    areAllMinimized,
  };
}
